export default {"src":"/_next/static/media/facebook.4b2ebb04.svg","height":12,"width":8};